export default function() {
  return [
    {
      title: "IOS INAPPS",
      to: "/ios-inapps",
      htmlBefore: '<i class="material-icons">vertical_split</i>',
      htmlAfter: ""
    },
    {
      title: "ANDROID INAPPS",
      htmlBefore: '<i class="material-icons">vertical_split</i>',
      to: "/android-inapps",
    },
    {
      title: "STUDIOBO",
      htmlBefore: '<i class="material-icons">note_add</i>',
      to: "/studiobo",
    },
    {
      title: "INAPP DETAILS",
      htmlBefore: '<i class="material-icons">view_module</i>',
      to: "/inapp-details",
    },
    // {
    //   title: "LOGOUT",
    //   htmlBefore: '<i class="material-icons">view_module</i>',
    //   to: "/login",
    // },
    // {
    //   title: "Tables",
    //   htmlBefore: '<i class="material-icons">table_chart</i>',
    //   to: "/tables",
    // },Copyright © 2019 GeniTeam
    // {
    //   title: "User Profile",
    //   htmlBefore: '<i class="material-icons">person</i>',
    //   to: "/user-profile-lite",
    // },
    // {
    //   title: "Errors",
    //   htmlBefore: '<i class="material-icons">error</i>',
    //   to: "/errors",
    // }
  ];
}
